import { NumericFormat } from 'react-number-format';
import { t } from "i18next";
import cx from "classnames";
import _ from 'lodash';
import { colornames } from 'color-name-list';

const formatterCreateAt = (time = 0, type = "full", tz = "Asia/Ho_Chi_Minh") => () => {
	if (!Date.parse(time)) time = +time;
	if (parseInt(time) > 0) {
		var d = new Date(time);

		if (tz) {
			d = convertTZ(d, tz);
		}
		var month = '' + (d.getMonth() + 1);
		var day = '' + d.getDate();
		var year = d.getFullYear();
		var hour = '' + (d.getHours());
		var min = '' + d.getMinutes();
		var sec = '' + d.getSeconds();

		if (month.length < 2)
			month = '0' + month;
		if (day.length < 2)
			day = '0' + day;
		if (hour.length < 2)
			hour = '0' + hour;
		if (min.length < 2)
			min = '0' + min;
		if (sec.length < 2)
			sec = '0' + sec;

		if (type === "dmy") {
			return [day, month, year].join('-');
		}
		return [day, month, year].join('-') + ' ' + [hour, min, sec].join(':');
	} else {
		return 'Updating';
	}

};

const daysSince = (dateString) => () => {
	const start = new Date(dateString);
	const now = new Date();
	const diffMs = now - start; // chênh lệch mili-giây
	const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
	if(diffDays === 0) {
		return "Today";
	}
	return `${diffDays} day(s)`;
}

const convertTZ = (date, tzString = "Asia/Ho_Chi_Minh") => {
	return new Date((typeof date === "string" ? new Date(date) : date).toLocaleString("en-US", { timeZone: tzString }));
}

const getTZOffset = () => {
	var offset = new Date().getTimezoneOffset();
	var o = -offset;
	return Math.floor(o / 60);
}

const getRange2TZ = (utc_offset = 0) => {
	var tz = getTZOffset();
	// if (tz === 7) {
	return tz - utc_offset;
	// }
	// var start = 0;
	// var end = 0;
	// if (utc_offset > 7) {
	// 	start = 7;
	// 	end = utc_offset;
	// } else {
	// 	start = utc_offset;
	// 	end = 7;
	// }
	// var list = [];
	// for (var i = start; i <= end; i++) {
	// 	list.push(i);
	// }
	// var range = 0;
	// if (utc_offset > 7) {
	// 	range = -list.length;
	// } else {
	// 	range = list.length;
	// }
	// return range-utc_offset >= 24 ? range-utc_offset-24 : range;
}

const getTimezoneOffset = (atTime, timeZone) => {
	const localizedTime = new Date(atTime.toLocaleString("en-US", { timeZone }));
	const utcTime = new Date(atTime.toLocaleString("en-US", { timeZone: "UTC" }));
	var timezone_offset = Math.round((localizedTime.getTime() - utcTime.getTime()) / (60 * 1000));

	return Math.floor(timezone_offset / 60);
}

const FormatterStatus = (props) => () => {
	var { status, small = false, large = false, type = "success" } = props;

	if (status === "active" || status === 1 || status === true) {
		return <span className={cx("badge badge-light-success", { "badge-sm": small, "fs-xl": large })}>Active</span>;
	} else if (status === "ACTIVATE") {
		return <span className={cx("badge badge-light-success", { "badge-sm": small, "fs-xl": large })}>ACTIVATE</span>;
	} else if (status === "In Stock") {
		return <span className={cx("badge badge-light-success", { "badge-sm": small, "fs-xl": large })}>In Stock</span>;
	} else if (status === "inactive" || status === 0 || status === false) {
		return <span className={cx("badge badge-light-warning", { "badge-sm": small, "fs-xl": large })}>Inactive</span>;
	} else if (status === "Low Stock") {
		return <span className={cx("badge badge-light-warning", { "badge-sm": small, "fs-xl": large })}>Low Stock</span>;
	} else if (status === "issue") {
		return <span className={cx("badge badge-light-danger", { "badge-sm": small, "fs-xl": large })}>Issue</span>;
	} else if (status === "Out Of Stock") {
		return <span className={cx("badge badge-light-danger", { "badge-sm": small, "fs-xl": large })}>Out Of Stock</span>;
	} else if (status === "FAILED") {
		return <span className={cx("badge badge-light-danger", { "badge-sm": small, "fs-xl": large })}>FAILED</span>;
	} else if (status === "SELLER_DEACTIVATED") {
		return <span className={cx("badge badge-light-danger", { "badge-sm": small, "fs-xl": large })}>SELLER_DEACTIVATED</span>;
	} else if (status === "PLATFORM_DEACTIVATED") {
		return <span className={cx("badge badge-light-danger", { "badge-sm": small, "fs-xl": large })}>PLATFORM_DEACTIVATED</span>;
	} else if (status === "DELETED" || status === "Deleted") {
		return <span className={cx("badge badge-light-danger", { "badge-sm": small, "fs-xl": large })}>DELETED</span>;
	} else if (status === "FREEZE") {
		return <span className={cx("badge badge-light-info", { "badge-sm": small, "fs-xl": large })}>FREEZE</span>;
	} else if (status === "draft") {
		return <span className={cx("badge badge-light-info", { "badge-sm": small, "fs-xl": large })}>Draft</span>;
	} else if (status === "DRAFT") {
		return <span className={cx("badge badge-light-info", { "badge-sm": small, "fs-xl": large })}>DRAFT</span>;
	} else if (status === "pending") {
		return <span className={cx("badge badge-light-warning", { "badge-sm": small, "fs-xl": large })}>Pending</span>;
	} else if (status === "PENDING") {
		return <span className={cx("badge badge-light-warning", { "badge-sm": small, "fs-xl": large })}>PENDING</span>;
	} else if (status === "UPLOADING") {
		return <span className={cx("badge badge-light-info", { "badge-sm": small, "fs-xl": large })}>UPLOADING</span>;
	} else if (status === "processing") {
		return <span className={cx("badge badge-light-warning", { "badge-sm": small, "fs-xl": large })}>Processing</span>;
	} else if (status === "approved") {
		return <span className={cx("badge badge-light-primary", { "badge-sm": small, "fs-xl": large })}>Approved</span>;
	} else if (status === "cancel") {
		return <span className={cx("badge badge-light-danger", { "badge-sm": small, "fs-xl": large })}>Cancel</span>;
	} else if (status === "unfulfilled") {
		return <span className={cx("badge badge-light-secondary", { "badge-sm": small, "fs-xl": large })}>Unfulfilled</span>;
	} else if (status === "on_delivery") {
		return <span className={cx("badge badge-light-success", { "badge-sm": small, "fs-xl": large })}>On Delivery</span>;
	} else if (status === "completed") {
		return <span className={cx("badge badge-light-success", { "badge-sm": small, "fs-xl": large })}>Completed</span>;
	} else if (status === "paid") {
		return <span className={cx("badge badge-light-success", { "badge-sm": small, "fs-xl": large })}>Paid</span>;
	} else if (status === "unpaid") {
		return <span className={cx("badge badge-light-secondary", { "badge-sm": small, "fs-xl": large })}>Unpaid</span>;
	} else if (status === "custom") {
		return <span className={cx("badge badge-light-info", { "badge-sm": small, "fs-xl": large })}>Custom</span>;
	} else if (status === "processing_fulfill") {
		return <span className={cx("badge badge-light-warning", { "badge-sm": small, "fs-xl": large })}>Processing Fulfill</span>;
	} else if (status === "on_hold") {
		return <span className={cx("badge badge-light-danger", { "badge-sm": small, "fs-xl": large })}>On Hold</span>;
	} else if (status === "refunded") {
		return <span className={cx("badge badge-light-danger", { "badge-sm": small, "fs-xl": large })}>Refunded</span>;
	} else if (status === "fulfilled") {
		return <span className={cx("badge badge-light-success", { "badge-sm": small, "fs-xl": large })}>Fulfilled</span>;
	} else if (status === "partially_refunded") {
		return <span className={cx("badge badge-light-warning", { "badge-sm": small, "fs-xl": large })}>Partially Refunded</span>;
	} else if (status === "maintaince") {
		return <span className={cx("badge badge-light-danger", { "badge-sm": small, "fs-xl": large })}>Maintaince</span>;
	} else if (status === "show") {
		return <span className={cx("badge badge-light-success", { "badge-sm": small, "fs-xl": large })}>show</span>;
	} else if (status === "hide") {
		return <span className={cx("badge badge-light-secondary", { "badge-sm": small, "fs-xl": large })}>hide</span>;
	} else if (status === "urgent") {
		return <span className={cx("badge badge-light-danger", { "badge-sm": small, "fs-xl": large })}>URGENT</span>;
	} else if (status === "partially_paid") {
		return <span className={cx("badge badge-light-secondary", { "badge-sm": small, "fs-xl": large })}>Partially Paid</span>;
	} else if (status === "hold") {
		return <span className={cx("badge badge-light-warning", { "badge-sm": small, "fs-xl": large })}>Hold</span>;
	} else if (status === true) {
		return <span className={cx("badge badge-light-success", { "badge-sm": small, "fs-xl": large })}>TRUE</span>;
	} else if (status === false) {
		return <span className={cx("badge badge-light-danger", { "badge-sm": small, "fs-xl": large })}>FALSE</span>;
	} else if (status === "Connected") {
		return <span className={cx("badge badge-light-success", { "badge-sm": small, "fs-xl": large })}>Connected</span>;
	} else if (status === "Disconnected") {
		return <span className={cx("badge badge-light-danger", { "badge-sm": small, "fs-xl": large })}>Disconnected</span>;
	} else if (status === "new") {
		return <span className={cx("badge badge-light-primary", { "badge-sm": small, "fs-xl": large })}>New</span>;
	} else if (status === "working") {
		return <span className={cx("badge badge-light-info", { "badge-sm": small, "fs-xl": large })}>Working</span>;
	} else if (status === "worked") {
		return <span className={cx("badge badge-light-success", { "badge-sm": small, "fs-xl": large })}>Worked</span>;
	} else if (status === "overdue") {
		return <span className={cx("badge badge-light-danger", { "badge-sm": small, "fs-xl": large })}>Overdue</span>;
	} else if (status === "ship_late") {
		return <span className={cx("badge badge-danger", { "badge-sm": small, "fs-xl": large })}>Ship Late</span>;
	} else if (status === "Refund issued") {
		return <span className={cx("badge badge-danger", { "badge-sm": small, "fs-xl": large })}>Refund issued</span>;
	} else if (status === "expired") {
		return <span className={cx("badge badge-light-danger", { "badge-sm": small, "fs-xl": large })}>Expired</span>;
	} else if (status === "ON_HOLD") {
		return <span className={cx("badge badge-light-secondary", { "badge-sm": small, "fs-xl": large })}>ON_HOLD</span>;
	} else if (status === "AWAITING_SHIPMENT") {
		return <span className={cx("badge badge-light-warning", { "badge-sm": small, "fs-xl": large })}>AWAITING_SHIPMENT</span>;
	} else if (status === "AWAITING_COLLECTION") {
		return <span className={cx("badge badge-light-info", { "badge-sm": small, "fs-xl": large })}>AWAITING_COLLECTION</span>;
	} else if (status === "IN_TRANSIT") {
		return <span className={cx("badge badge-light-primary", { "badge-sm": small, "fs-xl": large })}>IN_TRANSIT</span>;
	} else if (status === "DELIVERED") {
		return <span className={cx("badge badge-light-success", { "badge-sm": small, "fs-xl": large })}>DELIVERED</span>;
	} else if (status === "COMPLETED") {
		return <span className={cx("badge badge-light-dark", { "badge-sm": small, "fs-xl": large })}>COMPLETED</span>;
	} else if (status === "warehouse_out") {
		return <span className={cx("badge badge-danger", { "badge-sm": small, "fs-xl": large })}>Warehouse Out</span>;
	} else if (status === "produced") {
		return <span className={cx("badge badge-light-info", { "badge-sm": small, "fs-xl": large })}>Produced</span>;
	} else if (status === "scan") {
		return <span className={cx("badge badge-light-primary", { "badge-sm": small, "fs-xl": large })}>Scan</span>;
	} else if (status === "media") {
		return <span className={cx("badge badge-light-warning", { "badge-sm": small, "fs-xl": large })}>Media</span>;
	} else if (status === "done") {
		return <span className={cx("badge badge-light-success", { "badge-sm": small, "fs-xl": large })}>Done</span>;
	} else {
		return <span className={cx(`badge badge-light-${type}`, { "badge-sm": small, "fs-xl": large })}>{status}</span>;
	}
}

const formatterImage = (url = "") => () => {
	if (url.includes("drive.google.com") && url.includes('/d/')) {
		var new_url = `https://drive.google.com/thumbnail?id=${url.split('/d/')?.[1]?.split('/')[0]}`;
		return new_url;
	} else {
		return url;
	}

};
const FormatterUsed = (props) => () => {
	var { status, small = false, large = false } = props;

	if (status === true) {
		return <span className={cx("badge badge-light-success", { "badge-sm": small, "fs-xl": large })}>TRUE</span>;
	} else if (status === false) {
		return <span className={cx("badge badge-light-danger", { "badge-sm": small, "fs-xl": large })}>FALSE</span>;
	} else {
		return "";
	}
}

const isEmptyObject = (obj) => () => {
	try {
		for (var key in obj) {
			if (Object.prototype.hasOwnProperty.call(obj, key)) {
				return false;
			}
		}
		return true;
	} catch (error) {
		return false;
	}
};

const splitVariants = (obj) => () => {
	try {
		return Object.entries(obj).reduce((r, [k, v]) => {
			var temp = [];
			r.forEach(s =>
				(Array.isArray(v) ? v : [v]).forEach(w =>
					(w && typeof w === 'object' && k !== "image" ? splitVariants(w)() : [w]).forEach(x =>
						temp.push(Object.assign({}, s, { [k]: x }))
					)
				)
			);
			return temp;
		}, [{}]);
	} catch (error) {
		return false;
	}
};

const convertKeyValuePair = (arr, media, price, quantity) => () => {
	try {
		var arr_tmp = [];
		return arr.reduce(function (r, e, i) {
			let obj = {};
			for (const [key, value] of Object.entries(e)) { // eslint-disable-line
				obj = {
					...obj,
					[value["key"]]: value["value"],
				};
			}
			arr_tmp.push({
				"_id": i,
				"thumbnail": media[0] || "",
				...obj,
				"seller_sku": "sku_" + (i + 1),
				// "base_cost": 0,
				"price": 0,
				"quantity": 20,
				// "compare_price": 0,
				// "out_of_stock": false,
				// currency_code
			});
			return arr_tmp;
		}, []);
	} catch (error) {
		return false;
	}
};

const FormatterMoney = (props) => {
	let {
		money = 0,
		currency = "USD", // có thể truyền VN, US, GB, DE, IT, ...
		currency_to = "",
		style = {},
		decimalScale = 2,
		is_split_100 = true,
		locale = "en-US",
		type = "html",
	} = props;

	let exchange_price = money;

	// dữ liệu mapping country -> currency -> symbol
	const currencyData = {
		VN: { code: "VND", symbol: "₫", locale: "vi-VN" },
		US: { code: "USD", symbol: "$", locale: "en-US" },
		GB: { code: "GBP", symbol: "£", locale: "en-GB" },
		DE: { code: "EUR", symbol: "€", locale: "de-DE" },
		IT: { code: "EUR", symbol: "€", locale: "it-IT" },
		FR: { code: "EUR", symbol: "€", locale: "fr-FR" },
		JP: { code: "JPY", symbol: "¥", locale: "ja-JP" },
		KR: { code: "KRW", symbol: "₩", locale: "ko-KR" },
		CN: { code: "CNY", symbol: "¥", locale: "zh-CN" },
		SG: { code: "SGD", symbol: "S$", locale: "en-SG" },
		TH: { code: "THB", symbol: "฿", locale: "th-TH" },
		ID: { code: "IDR", symbol: "Rp", locale: "id-ID" },
		ES: { code: "EUR", symbol: "€", locale: "es-ES" },
	};

	// nếu truyền country code thì đổi sang ISO currency
	if (currencyData[currency]) {
		locale = currencyData[currency].locale;
		currency = currencyData[currency].code;
	}

	// xử lý chia 100 cho các loại có cent
	// if (
	// 	is_split_100 &&
	// 	!["", "CLP", "COP", "CRC", "HUF", "ISK", "IDR", "JPY", "KRW", "PYG", "TWD", "VND"].includes(
	// 		currency
	// 	)
	// ) {
	// 	exchange_price = exchange_price / 100;
	// }

	// quy đổi ngoại tệ
	if (currency_to !== "") {
		if (getCookie("cotik_exchange_rate")()) {
			let exchange_rate = JSON.parse(getCookie("cotik_exchange_rate")());
			if (exchange_rate[currency]) {
				exchange_price = exchange_price / exchange_rate[currency];
				if (currencyData[currency_to]) {
					locale = currencyData[currency_to].locale;
					currency = currencyData[currency_to].code;
				} else {
					currency = currency_to;
				}
			}
		}
	}

	if (type === "number") {
		return exchange_price;
	}

	// format với Intl để lấy ký hiệu chính thức
	let formattedValue = new Intl.NumberFormat(locale, {
		style: "currency",
		currency,
		minimumFractionDigits: decimalScale,
		maximumFractionDigits: decimalScale,
	}).format(exchange_price);

	return <span style={style}>{formattedValue}</span>;
};

const isNumeric = (n) => {
	return !isNaN(parseFloat(n)) && isFinite(n);
}

const subStringText = (data, length = 45) => () => {
	return data?.length > length ? data.slice(0, length - 1) + "…" : data;
}

const sleep = (ms) => {
	return new Promise((res) => setTimeout(res, ms));
}

const getDatesInRange = (dateStart, dateEnd) => () => {
	const date = new Date(dateStart);

	const dates = [];

	while (date <= dateEnd) {
		dates.push(formatterCreateAt((new Date(date)).getTime(), "dmy")());
		date.setDate(date.getDate() + 1);
	}

	return dates;
}

const cleanObject = (obj) => () => {
	for (var propName in obj) {
		if (obj[propName] === null || obj[propName] === undefined || obj[propName] === "") {
			delete obj[propName];
		}
	}
	return obj;
};

const setCookie = (name, value, days) => () => {
	var expires = "";
	if (days) {
		var date = new Date();
		date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
		expires = "; expires=" + date.toUTCString();
	}
	document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

const getCookie = (name) => () => {
	var nameEQ = name + "=";
	var ca = document.cookie.split(';');
	for (var i = 0; i < ca.length; i++) {
		var c = ca[i];
		while (c.charAt(0) === ' ') c = c.substring(1, c.length);
		if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
	}
	return null;
}

const eraseCookie = (name) => () => {
	document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

const getDiffDays = (dateStart, dateEnd) => () => {
	const oneDay = 24 * 60 * 60 * 1000;
	const diffDays = Math.floor(Math.abs((dateStart - dateEnd) / oneDay));

	return diffDays;
};

const getStatusAcc = (num) => () => {
	let astatus = ""
	switch (num) {
		case 1:
			astatus = t("Active")
			break ///active
		case 2:
			astatus = t("Disable")
			break //disabled
		case 3:
			astatus = t("Need pay")
			break
		case 7:
			astatus = t("Pending Review") //PENDING_RISK_REVIEW
			break
		case 8:
			astatus = t("Pending Settlement")
			break
		case 9:
			astatus = t("IN_GRACE_PERIOD In") //IN_GRACE_PERIOD In
			break
		case 100:
			astatus = t("Pending Closure")
			break
		case 101:
			astatus = t("Close")
			break
		case 201:
			astatus = t("Any Active")
			break
		case 202:
			astatus = t("Any Close")
			break
		case "active":
			astatus = t("Any Close")
			break
		default:
			astatus = t("Active")
			break
	}
	return astatus
}

function checkImageURL(url) {
	return (url.match(/\.(jpeg|jpg|gif|png|webp)$/) != null);
}

const arrayHierarchy = (ar) => {
	const mapped = ar.reduce((acc, item) => {
		acc[item.id] = item;
		return acc;
	}, {});

	const result = ar.reduce((acc, item) => {
		const parentId = item.parent_id;
		if (!parentId || parentId === "0" || !mapped[parentId]) return [...acc, item];

		mapped[parentId].children = mapped[parentId].children || [];

		// mapped[parentId].children.push({ ...item, value: item.id, label: item.local_name, disabled: !item.is_leaf });
		const itemR = item;
		itemR.value = item.id;
		itemR.label = item.local_name;
		mapped[parentId].children.push(itemR);

		return acc;
	}, []);

	return result;
};

function getKeyByValue(object, value) {
	return Object.keys(object).find((key) => object[key] === value);
}

const permissionComponent = ({ user, permission, component, type = "hidden" }) => {
	if (user.role !== 2) return component;

	if (!user?.teamPermission?.includes(permission)) {
		if (type !== "hidden") {
			return (
				<div className="alert mb-0 alert-danger">
					<strong>Oops!</strong> You don't have permission to view this page.
				</div>
			);
		}

		return <></>;
	}

	return component;
};

const getDaysArray = function (start, end) {
	const arr = [];
	for (const dt = new Date(start); dt <= new Date(end); dt.setDate(dt.getDate() + 1)) {
		arr.push(new Date(dt).toLocaleDateString("en-CA"));
	}
	return arr;
};

const countString = (data) => () => {
	var uniqueCount = data?.replace(/,/g, "")?.split(" ");

	var map = {};
	var count = uniqueCount?.map(function (val) {
		return map[val] = (typeof map[val] === "undefined") ? 1 : map[val] + 1;
	});

	var newArray = uniqueCount?.map(function (val, index) {
		if (map[val] === 1) {
			return val;
		} else {
			return val + "|||" + count[index];
		}
	});

	newArray = newArray?.filter((v, i) => parseInt(v?.split("|||")[1]) > 3) || [];

	var messLog = "";

	if (newArray?.length > 0) {
		messLog = " (Warning: " + _.uniq(newArray?.map((v, i) => v.split("|||")[0])) + ")";
	}

	return messLog;
}

const toBase64 = file => new Promise((resolve, reject) => {
	const reader = new FileReader();
	reader.readAsDataURL(file);
	reader.onload = () => resolve(reader.result);
	reader.onerror = reject;
});

const scaleNumber = ({ number, fix = 2 }) => () => {
	if (fix !== 0) {
		const fixed = Math.pow(10, fix);
		const epsilon = fix !== 1 ? Number.EPSILON : 0;
		return (Math.ceil((parseFloat(number) + epsilon) * fixed) / fixed) || 0;
	}
	return Math.ceil(number);
};

const findMinQuantity = (skus) => () => {
	var min = _.minBy(skus, "quantity")?.quantity || 0;
	return min;
}

const findKey = (obj, targetKey) => {
	if (Array.isArray(obj)) {
		for (const item of obj) {
			const result = findKey(item, targetKey);
			if (result) return result;
		}
	} else if (typeof obj === "object" && obj !== null) {
		for (const key in obj) {
			if (key === targetKey) return obj[key];
			const result = findKey(obj[key], targetKey);
			if (result) return result;
		}
	}
}

const parseJson = (json) => {
	try {
		return JSON.parse(json);
	} catch (error) {
		return null;
	}
}

const stringifyJson = (data) => {
	function converter(key, val) {
		if (typeof val === 'function' || (val && val.constructor === RegExp)) {
			return String(val)
		}
		return val;
	}

	return JSON.stringify(data, converter, 2);
}

const sortArrByCondition = (data, cPosition) => {
	if (cPosition && cPosition.length) {
		const withoutId = data.filter(item => !item.field);
		const result = data.filter((item) => item.field).sort((a, b) => {
			const indexA = cPosition.indexOf(a.field);
			const indexB = cPosition.indexOf(b.field);

			if (indexA === -1 && indexB === -1) return 0;
			if (indexA === -1) return 1;
			if (indexB === -1) return -1;

			return indexA - indexB;
		});

		return [...withoutId, ...result]
	}

	return data;
}

const toAbbreviation = (stateName) => {
	const nameParts = stateName.split(" ");

	if (nameParts.length > 2) {
		return nameParts
			.map(word => word[0].toUpperCase())
			.join("");
	}

	return stateName;
};

const getLevelByCount = (arr) => {
	const sortedArr = [...arr].sort((a, b) => b.count - a.count);

	let rank = 1;
	for (let i = 0; i < sortedArr.length; i++) {
		if (i > 0 && sortedArr[i].count === sortedArr[i - 1].count) {
			sortedArr[i].rank = sortedArr[i - 1].rank;
		} else {
			sortedArr[i].rank = rank;
		}
		rank = (sortedArr[i].rank === rank) ? rank + 1 : rank;
	}
	return sortedArr;
}

const colorsForNearest = Object.fromEntries(
	colornames.map(({ name, hex }) => [name.toLowerCase().replace(/ /g, ""), hex])
);

const levenshteinDistance = (a, b) => {
	const matrix = [];
	for (let i = 0; i <= b.length; i++) {
		matrix[i] = [i];
	}
	for (let j = 0; j <= a.length; j++) {
		matrix[0][j] = j;
	}
	for (let i = 1; i <= b.length; i++) {
		for (let j = 1; j <= a.length; j++) {
			if (b.charAt(i - 1) === a.charAt(j - 1)) {
				matrix[i][j] = matrix[i - 1][j - 1];
			} else {
				matrix[i][j] = Math.min(
					matrix[i - 1][j - 1] + 1,
					matrix[i][j - 1] + 1,
					matrix[i - 1][j] + 1
				);
			}
		}
	}
	return matrix[b.length][a.length];
}

const findHexAndNearestHex = (color) => {
	if (!color) {
		return undefined;
	}
	let bestMatch = null;
	let smallestDistance = Infinity;

	for (const colorName in colorsForNearest) {
		const distance = levenshteinDistance(color?.toLowerCase()?.replace(/ /g, ""), colorName?.toLowerCase()?.replace(/ /g, ""));
		if (distance < smallestDistance) {
			smallestDistance = distance;
			bestMatch = colorName;
		}
	}

	const threshold = 5;
	if (smallestDistance > threshold) {
		return undefined;
	}

	return colorsForNearest[bestMatch];
}

const convertPrinterCotikPartner = (list_color, list_size, printer, prev) => () => {
	var manufacturer = "";
	if (prev?.manufacturer === "cotik_gildan") {
		// "onospod", "kvfulfill", "visiovsolutions", "saigongroups", "hogotopod_alloverprint", "treesprint", "bullstart"
		if (["flashship", "hmfulfill", "lenful", "printeeshub", "printiz", "printify", "oneprint", "menprint", "merchize", "pressify", "smartfactore", "lizyprintfull", "sellerwix", "anprints", "dreamship", "merchfox", "printory"].includes(printer)) {
			manufacturer = "gildan";
		}
		if (["mangoteeprints", "gearment", "a2kecom"].includes(printer)) {
			manufacturer = "gildantiktok";
		}
		if (["monkeykingprint"].includes(printer)) {
			manufacturer = "classicgildan_monkey";
		}
		if (["burgerprints"].includes(printer)) {
			manufacturer = "gildanus";
		}
		if (["teroprints"].includes(printer)) {
			manufacturer = "teroprints_alloverprint";
		}
		if (["fprint"].includes(printer)) {
			manufacturer = "fprint_gildan";
		}
	}
	if (prev?.manufacturer === "cotik_bellacanvas") {
		// "onospod", "kvfulfill", "visiovsolutions", "saigongroups", "monkeykingprint", "teroprints_alloverprint", "sellerwix", "hogotopod_alloverprint"
		if (["flashship", "hmfulfill", "lenful", "printiz", "printify", "menprint", "merchize", "lizyprintfull", "anprints", "dreamship", "merchfox"].includes(printer)) {
			manufacturer = "bellacanvas";
		}
		if (["mangoteeprints", "gearment", "a2kecom"].includes(printer)) {
			manufacturer = "bellacanvastiktok";
		}
		if (["burgerprints"].includes(printer)) {
			manufacturer = "bellacanvasus";
		}
		if (["fprint"].includes(printer)) {
			manufacturer = "fprint_bellacanvas";
		}
	}
	if (prev?.manufacturer === "cotik_comfort") {
		// "onospod", "kvfulfill", "visiovsolutions", "saigongroups", "teroprints_alloverprint", "hogotopod_alloverprint"
		if (["flashship", "hmfulfill", "lenful", "printiz", "printify", "menprint", "merchize", "pressify", "lizyprintfull", "sellerwix", "anprints", "dreamship", "merchfox"].includes(printer)) {
			manufacturer = "comfort";
		}
		if (["mangoteeprints", "gearment", "a2kecom"].includes(printer)) {
			manufacturer = "comforttiktok";
		}
		if (["monkeykingprint"].includes(printer)) {
			manufacturer = "comfort_monkey";
		}
		if (["burgerprints"].includes(printer)) {
			manufacturer = "comfortus";
		}
		if (["fprint"].includes(printer)) {
			manufacturer = "fprint_comfort";
		}
	}
	if (prev?.manufacturer === "cotik_canvas") {
		if (["mangoteeprints"].includes(printer)) {
			manufacturer = "canvastiktok";
		}
	}
	if (prev?.manufacturer === "cotik_poster") {
		if (["mangoteeprints"].includes(printer)) {
			manufacturer = "postertiktok";
		}
	}

	var type = "";
	if (prev?.type === "tshirt_g5000") {
		if (manufacturer === "gildan" || manufacturer === "fprint_gildan") {
			type = "tshirt_g5000";
		}
		if (manufacturer === "gildantiktok") {
			type = "tshirt_5000_tiktok";
		}
		if (manufacturer === "classicgildan_monkey") {
			type = "Classic T-Shirt";
		}
		if (manufacturer === "gildanus") {
			type = "tshirt_5000_us";
		}
		if (manufacturer === "teroprints_alloverprint") {
			type = "aopt";
		}
	}
	if (prev?.type === "sweatshirt_g18000") {
		if (manufacturer === "gildan" || manufacturer === "fprint_gildan") {
			type = "sweatshirt_g18000";
		}
		if (manufacturer === "gildantiktok") {
			type = "sweatshirt_18000_tiktok";
		}
		if (manufacturer === "classicgildan_monkey") {
			type = "Sweatshirt";
		}
		if (manufacturer === "gildanus") {
			type = "sweatshirt_18000_us";
		}
		if (manufacturer === "teroprints_alloverprint") {
			type = "aops";
		}
	}
	if (prev?.type === "hoodie_g18500") {
		if (manufacturer === "gildan" || manufacturer === "fprint_gildan") {
			type = "hoodie_g18500";
		}
		if (manufacturer === "gildantiktok") {
			type = "hoodie_18500_tiktok";
		}
		if (manufacturer === "classicgildan_monkey") {
			type = "Hoodie";
		}
		if (manufacturer === "gildanus") {
			type = "hoodie_18500_us";
		}
		if (manufacturer === "teroprints_alloverprint") {
			type = "aopph";
		}
	}
	if (prev?.type === "youthtshirt_g5000b") {
		if (manufacturer === "gildan") {
			type = "youthtshirt_g5000b";
		}
		if (manufacturer === "gildantiktok") {
			type = "kidstshirt_5000b_tiktok";
		}
		if (manufacturer === "classicgildan_monkey") {
			type = "Youth T-Shirt";
		}
		// if (manufacturer === "gildanus") {
		// 	type = "kidstshirt_5000b_us";
		// }
	}
	if (prev?.type === "tshirt_b3001") {
		if (manufacturer === "bellacanvas" || manufacturer === "fprint_bellacanvas") {
			type = "tshirt_b3001";
		}
		if (manufacturer === "bellacanvastiktok") {
			type = "tshirt_3001";
		}
		if (manufacturer === "bellacanvasus") {
			type = "tshirt_3001_us";
		}
	}
	if (prev?.type === "tshirt_c1717") {
		if (manufacturer === "comfort" || manufacturer === "fprint_comfort") {
			type = "tshirt_c1717";
		}
		if (manufacturer === "comforttiktok") {
			type = "tshirt_1717";
		}
		if (manufacturer === "comfort_monkey") {
			type = "Comfort color T-shirt";
		}
		if (manufacturer === "comfort_monkey") {
			type = "tshirt_1717_us";
		}
	}
	if (prev?.type === "0.75_thickness_canvas") {
		type = prev?.type;
	}
	if (prev?.type === "premium_satin_poster") {
		type = prev?.type;
	}
	if (prev?.type === "standard_satin_poster") {
		type = prev?.type;
	}

	var printing_area = 0;
	if (prev?.printing_area === "oneside") {
		if (["lenful"].includes(printer)) {
			printing_area = "oneside";
		}
	}
	if (prev?.printing_area === "bothsides") {
		if (["lenful"].includes(printer)) {
			printing_area = "bothsides";
		}
		if (["gearment"].includes(printer)) {
			printing_area = "both";
		}
	}

	var production_config = "";
	if (["printiz"].includes(printer)) {
		production_config = prev?.production_config;
	}
	if (["mangoteeprints"].includes(printer)) {
		production_config = prev?.production_config?.toLowerCase()?.includes("large") ? "large" : "default";
	}

	var shipping_method = "";
	if (prev?.shipping_method === "standard") {
		if (["mangoteeprints", "monkeykingprint", "printeeshub", "visiovsolutions", "saigongroups", "fprint", "merchize"].includes(printer)) {
			shipping_method = "standard";
		}
		if (["gearment"].includes(printer)) {
			shipping_method = "0";
		}
		if (["hmfulfill"].includes(printer)) {
			shipping_method = "1";
		}
		if (["a2kecom", "menprint"].includes(printer)) {
			shipping_method = "standard_ship";
		}
		if (["printiz"].includes(printer)) {
			shipping_method = "Standard";
		}
		if (["printify"].includes(printer)) {
			shipping_method = "1";
		}
	}
	if (prev?.shipping_method === "priority") {
		if (["flashship"].includes(printer)) {
			shipping_method = "2";
		}
		if (["mangoteeprints", "monkeykingprint"].includes(printer)) {
			shipping_method = "priority";
		}
		if (["hmfulfill"].includes(printer)) {
			shipping_method = "3";
		}
		if (["burgerprints"].includes(printer)) {
			shipping_method = "priority express";
		}
		if (["printiz"].includes(printer)) {
			shipping_method = "Priority";
		}
		if (["printify"].includes(printer)) {
			shipping_method = "2";
		}
	}
	if (prev?.shipping_method === "express") {
		if (["mangoteeprints", "monkeykingprint", "burgerprints"].includes(printer)) {
			shipping_method = "express";
		}
		if (["printiz"].includes(printer)) {
			shipping_method = "Express";
		}
		if (["printify"].includes(printer)) {
			shipping_method = "3";
		}
	}
	if (prev?.shipping_method === "rush") {
		if (["flashship"].includes(printer)) {
			shipping_method = "3";
		}
		if (["visiovsolutions"].includes(printer)) {
			shipping_method = "rush";
		}
		if (["printeeshub"].includes(printer)) {
			shipping_method = "rush_product";
		}
	}
	if (prev?.shipping_method === "expedite") {
		if (["flashship"].includes(printer)) {
			shipping_method = "6";
		}
		if (["monkeykingprint"].includes(printer)) {
			shipping_method = "expedite";
		}
		if (["printeeshub"].includes(printer)) {
			shipping_method = "expedite_tiktok";
		}
	}
	if (prev?.shipping_method === "global") {
		if (["mangoteeprints"].includes(printer)) {
			shipping_method = "global";
		}
	}

	var color = list_color.find((v, i) => v?.value === prev?.color && v?.enabled?.includes(type))?.value || "";

	var size = list_size.find((v, i) => v?.value === prev?.size && v?.enabled?.includes(type))?.value || "";

	return { ...prev, printer, manufacturer, type, printing_area, production_config, shipping_method, color, size };
}

export function formatNumberShort(num) {
	if (num === null || num === undefined || isNaN(num)) return num;
	if (Math.abs(num) >= 1_000_000_000) return (num / 1_000_000_000).toFixed(1) + "B";
	if (Math.abs(num) >= 1_000_000) return (num / 1_000_000).toFixed(1) + "M";
	if (Math.abs(num) >= 1_000) return (num / 1_000).toFixed(1) + "K";
	return Number(num).toLocaleString();
}

function getQueryParams() {
	const params = new URLSearchParams(window.location.search);
	const filter = {};
	for (const [key, value] of params.entries()) {
		if (key === "page") continue;
		if (key === "product_categories") {
			filter.product_categories = value?.split?.(",") || "";
			continue;
		}
		if (key === "influencer_categories") {
			filter.influencer_categories = value?.split?.(",") || "";
			continue;
		}
		if (value) filter[key] = value;
	}
	const page = parseInt(params.get("page"), 10) || 1;
	return { filter, page };
}

const FlagRegionByIso = (props) => {
	var { name = "", iso = "" } = props;

	if (!name && !iso) {
		return "";
	}

	return <span className="symbol symbol-20px" data-tooltip-id="my-tooltip" data-tooltip-content={name}>
		{
			iso === "us" ?
				<img src={require("components/assets/media/flags/united-states.svg").default} alt="" />
				: iso === "mx" ?
					<img src={require("components/assets/media/flags/mexico.svg").default} alt="" />
					: iso === "br" ?
						<img src={require("components/assets/media/flags/brazil.svg").default} alt="" />
						: iso === "vn" ?
							<img src={require("components/assets/media/flags/vietnam.svg").default} alt="" />
							: iso === "th" ?
								<img src={require("components/assets/media/flags/thailand.svg").default} alt="" />
								: iso === "ph" ?
									<img src={require("components/assets/media/flags/philippines.svg").default} alt="" />
									: iso === "my" ?
										<img src={require("components/assets/media/flags/malaysia.svg").default} alt="" />
										: iso === "id" ?
											<img src={require("components/assets/media/flags/indonesia.svg").default} alt="" />
											: iso === "sg" ?
												<img src={require("components/assets/media/flags/singapore.svg").default} alt="" />
												: iso === "jp" ?
													<img src={require("components/assets/media/flags/japan.svg").default} alt="" />
													: iso === "gb" ?
														<img src={require("components/assets/media/flags/uk.svg").default} alt="" />
														: iso === "es" ?
															<img src={require("components/assets/media/flags/spain.svg").default} alt="" />
															: iso === "de" ?
																<img src={require("components/assets/media/flags/germany.svg").default} alt="" />
																: iso === "it" ?
																	<img src={require("components/assets/media/flags/italy.svg").default} alt="" />
																	: iso === "fr" ?
																		<img src={require("components/assets/media/flags/france.svg").default} alt="" />
																		: ""
		}
	</span>;
}

export function stringToSlug(str) {
	return str
		.toLowerCase()
		.normalize('NFD')
		.trim()
		.replace(/\s+/g, '-')
		.replace(/-+/g, '-');
}

export {
	formatterCreateAt,
	FormatterStatus,
	isEmptyObject,
	FormatterMoney,
	splitVariants,
	convertKeyValuePair,
	isNumeric,
	subStringText,
	sleep,
	getDatesInRange,
	cleanObject,
	convertTZ,
	getRange2TZ,
	setCookie,
	getCookie,
	eraseCookie,
	getDiffDays,
	getTimezoneOffset,
	getStatusAcc,
	checkImageURL,
	arrayHierarchy,
	FormatterUsed,
	getKeyByValue,
	permissionComponent,
	getDaysArray,
	formatterImage,
	countString,
	toBase64,
	scaleNumber,
	findMinQuantity,
	findKey,
	parseJson,
	stringifyJson,
	sortArrByCondition,
	toAbbreviation,
	getLevelByCount,
	findHexAndNearestHex,
	convertPrinterCotikPartner,
	getQueryParams,
	FlagRegionByIso,
	daysSince,
}